var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckedBill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0.5V9.5H8.49C8.33064 9.01597 8.24962 8.50959 8.25 8H3.75C3.75 7.60218 3.59196 7.22064 3.31066 6.93934C3.02936 6.65804 2.64782 6.5 2.25 6.5V3.5C3.0825 3.5 3.75 2.8325 3.75 2H11.25C11.25 2.39782 11.408 2.77936 11.6893 3.06066C11.9706 3.34196 12.3522 3.5 12.75 3.5V3.545C13.2525 3.545 13.755 3.635 14.25 3.8V0.5H0.75ZM7.5 2.75C6.225 2.7725 5.25 3.725 5.25 5C5.25 6.275 6.225 7.205 7.5 7.25C7.785 7.25 8.0775 7.19 8.355 7.0775C8.5575 6.2525 8.895 5.4725 9.7275 4.7075C9.6375 3.71 8.6925 2.7275 7.5 2.75ZM14.7225 5.2025L11.82 8.1275L10.8075 7.1L9.75 8.165L11.8125 10.25L15.7725 6.26L14.7225 5.2025Z",
    fill: "#64A4A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedBill);
export default __webpack_public_path__ + "static/media/CheckedBill.d0b5a7a16c16ad3c59aab436a215de16.svg";
export { ForwardRef as ReactComponent };